import hcHeaderImg from "../../../../src/images/hc-header-banner.png";
import * as React from 'react';
export default {
  hcHeaderImg,
  React
};